import { Link, Outlet, useLocation, useParams } from 'react-router-dom';
import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  HStack,
  Image,
} from '@chakra-ui/react';

import { ReactComponent as ChevronRightIcon } from '../../assets/icons/chevron-right.svg';
import { useGetRoleByIdQuery } from '../../services';

export const RolesLayout = () => {
  const location = useLocation();
  const params = useParams();
  const { roleId } = params;
  const status = params.status || 'all';

  const { data: savedRole } = useGetRoleByIdQuery(Number(roleId), {
    skip: !roleId,
  });

  return (
    <Box mx="8" h="full" display="flex" flexDirection="column">
      <Breadcrumb separator={<ChevronRightIcon />}>
        <BreadcrumbItem>
          <HStack fontSize="xs" color="custom_blue.1">
            <Image src="/sidebar/roles.svg" alt="roles icon" boxSize="4" />
            <Box>Roles</Box>
          </HStack>
        </BreadcrumbItem>

        <BreadcrumbItem isCurrentPage={location.pathname.endsWith(status)}>
          <BreadcrumbLink
            as={Link}
            to={`/roles/${status}`}
            fontSize="xs"
            color="custom_blue.1"
            textTransform="capitalize"
          >
            {status ? status : 'All'} Roles
          </BreadcrumbLink>
        </BreadcrumbItem>

        {(location.pathname.includes('new-role') || roleId) && (
          <BreadcrumbItem
            isCurrentPage={location.pathname.endsWith('new-role')}
          >
            {roleId ? (
              <BreadcrumbLink
                as={Link}
                to={`/companies/${status}/${roleId}`}
                fontSize="xs"
                color="custom_blue.1"
              >
                {savedRole?.data?.name}
              </BreadcrumbLink>
            ) : (
              <BreadcrumbLink
                as={Link}
                to={`/roles/${status}/new-role`}
                fontSize="xs"
                color="custom_blue.1"
              >
                Add New Role
              </BreadcrumbLink>
            )}
          </BreadcrumbItem>
        )}
      </Breadcrumb>

      <Outlet />
    </Box>
  );
};
